<div id="payment-dialog-container">
  <!-- Header -->
  <div class="flex-space-between">
    <div class="title margin-right-1">{{ title | translate }}</div>
    <button mat-icon-button color="warn" (click)="closeDialog()">
      <mat-icon svgIcon="close-circle"></mat-icon>
    </button>
  </div>
  <div class="mat-h4">
    {{ "need-to-buy-hours" | translate }}
  </div>
  <div class="margin-top-05">
    {{ "price-per-hour" | translate }}:
    {{ data.priceHour ? data.priceHour : "-" }} €
  </div>
  <form [formGroup]="form" (ngSubmit)="sendForm()">
    <!-- Phone -->
    <mat-form-field appearance="legacy" class="margin-top-1">
      <mat-label>{{ "hours" | translate }}</mat-label>
      <input
        matInput
        formControlName="hours"
        type="number"
        onkeydown=" return ![69, 190].includes(event.keyCode)"
        name="hours"
        autocomplete="hours"
      />
      <mat-error *ngIf="hoursInvalid">
        {{ "valid-input" | translate }}
      </mat-error>
    </mat-form-field>

    <div *ngIf="totalPrice">{{ "total" | translate }}: {{ totalPrice }} €</div>

    <!-- Pay with -->
    <mat-radio-group
      class="radio-group"
      formControlName="paymentMethod"
      [color]="'primary'"
    >
      <mat-radio-button class="radio-button" value="paypal">
        <img src="assets/img/paypal.png" />
      </mat-radio-button>
      <mat-radio-button class="radio-button" value="redsys">
        <mat-icon class="margin-right-05" svgIcon="card"></mat-icon>
        {{ "payment-with-card" | translate }}
      </mat-radio-button>
    </mat-radio-group>

    <div class="d-flex justify-content-center margin-auto">
      <button
        mat-raised-button
        color="primary"
        class="width-50 margin-top-1 margin-bottom-05 text-uppercase padding-05"
        [disabled]="form.invalid"
        type="submit"
      >
        <span>{{ "buy" | translate }}</span>
      </button>
    </div>
  </form>
</div>
